import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-column">
                <h3>Contácto</h3>
                <ul>
                    <li><a className="contact-link">300 107 9888</a></li>
                    <li><a className="contact-link">dra.gladysquintero@gmail.com</a></li>
                </ul>
            </div>
            <div className="footer-column">
                <h3>Dra. Gladys Eugenia Quintero Capera</h3>
                <ul>
                    <li><Link to="/Nosotros" className="hidden-link">Sobre mí</Link></li>
                    <li><Link to="/servicios/hidratación" className="hidden-link">Hidratación facial</Link></li>
                </ul>
            </div>
            <div className="footer-column">
                <h3>Servicios</h3>
                <ul>
                    <li><Link to="/tratamientos/capilar" className="hidden-link">Tratamientos capilares</Link></li>
                    <li><Link to="/tratamientos/corporal" className="hidden-link">Tratamientos corporales</Link></li>
                    <li><Link to="/tratamientos/facial" className="hidden-link">Tratamientos faciales</Link></li>
                </ul>
            </div>
            <div className="footer-column">
                <h3>Estética</h3>
                <ul>
                    <li><Link to="/servicios/mesocapilar" className="hidden-link">Mesocapilar</Link></li>
                    <li><Link to="/servicios/limpieza-facial" className="hidden-link">Limpieza facial</Link></li>
                    <li><Link to="/servicios/sueroterapia" className="hidden-link">Sueroterapia</Link></li>
                    <li><Link to="/servicios/acido-hialuronico" className="hidden-link">Acido hialuronico</Link></li>
                </ul>
            </div>
        </footer>
    );
};

export default Footer;